export default "__VITE_ASSET__7aa713a7__"